export function isOfLegalAge(dtNascimentoUsuarioC: string) {
	if (!dtNascimentoUsuarioC) return false;
	const [day, month, year] = dtNascimentoUsuarioC.split('/').map(Number);
	const birthDate = new Date(year, month - 1, day);
	const today = new Date();

	const age = today.getFullYear() - birthDate.getFullYear();
	const isBirthdayPassed =
		today.getMonth() > birthDate.getMonth() ||
		(today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

	return isBirthdayPassed ? age >= 18 : age - 1 >= 18;
}
